<template>
  <div>
    <div id="facture" class="typeDocument">
      <div v-if="invoices.length">
        <b-table class="text-center" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFilteredInvoices" responsive :striped="true" :fields="fieldsFactures" :items="invoices" :current-page="currentPageFactures" :per-page="perPage">
          <template v-slot:cell(statut)="data">
            <b-button style='font-size:12px;' variant="success" v-if="data.item.paye == 1">Payée</b-button>
            <b-button style='font-size:12px;' variant="danger" v-else-if="data.item.date_lim_sup != 0">Impayée</b-button>
            <b-button style='font-size:12px;' variant="warning" v-else>En attente</b-button>
          </template>
          <template v-slot:cell(date-creation)="data">
            <span style='font-size:12px;'>{{ data.item.date_creation }}</span>
          </template>
          <template v-slot:cell(date-reglement)="data">
            <span style='font-size:12px;'>{{ data.item.date_lim_reglement }}</span>
          </template>
          <template v-slot:cell(reference)="data">
            <span style='width:30%; font-size:12px; text-transform: uppercase;'>{{ data.item.ref_client }}</span>
          </template>
          <template v-slot:cell(prix-ht)="data">
            <span style='font-size:12px; text-transform: uppercase;'>{{ data.item.total_ht }}</span>
          </template>
          <template v-slot:cell(prix-ttc)="data">
            <span style='font-size:12px; text-transform: uppercase;'>{{ data.item.total_ttc }}</span>
          </template>
          <template v-slot:cell(document)="data">
            <span style='font-size:12px; text-transform: uppercase;'>{{ data.item.ref+'.pdf' }}</span>
          </template>
          <template v-slot:cell(download)="data">
            <a v-bind:href="'/api/downloadDoc/'+data.item.last_main_doc" download><span style="cursor:pointer;" class='fas fa-cloud-download-alt' v-b-tooltip.hover title='Télécharger'></span></a>
          </template>
          <template v-slot:cell(visual)="data">
            <a v-on:click.stop="visualFacTiers(data.item)"><span style="cursor:pointer;" class='far fa-eye' v-b-tooltip.hover title='Visualiser'></span></a>
          </template>
        </b-table>

        <div v-if="invoices.length>perPage">
          <b-pagination size="md" :total-rows="invoices.length" v-model="currentPageFactures" :per-page="perPage" />
        </div>
      </div>
      <div v-else>
        <h5>Aucunes factures disponibles</h5>
      </div>
    </div>
    <b-modal id="modalVisualFacTiers" @hide="resetModal" :title="modalVisualFacTiers.title" hide-footer>
      <template>
        <iframe id="visualDoc" v-bind:src="visualSrcFacTiers"></iframe>
      </template>
    </b-modal>
  </div>
</template>

<script>
import script from '../../../../script/script.js';
import scriptTiers from '../../../../script/script_tiers.js';
export default {
  data() {
    return {
      post: {},
      fieldsFactures:[{key:"statut", label:"Statut", sortable: true},{key:"date-creation", label:"Date de création"},{key:"date-reglement", label:"Date limite de règlement"},{key:"reference", label:"Référence"},{key:"prix-ht", label:"Total(ht*)"},{key:"prix-ttc", label:"Total(ttc*)"},{key:"document", label:"Document"},{key:"download", label:""},{key:"visual", label:""}],
      currentPageFactures: 1,
      perPage: 10,
      filter:null,
      sortBy: "statut",
      sortDesc: false,
      sortDirection: 'asc',
      isDocuments: false,
      modalVisualFacTiers: { title: '', content: '' },
      visualSrcFacTiers:''
    }
  },
  mounted:function(){
    this.loadDocuments("invoices");
  },
  methods: {
    verifyRight: script.verifyRight,
    loadDocuments: script.loadDocuments,
    visualFacTiers: scriptTiers.visualFacTiers,
    onFilteredInvoices(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.invoices.length = filteredItems.length
      this.currentPage = 1
    }
  },
  components: {

  },
  computed : {
    invoices(){
      return this.$store.state.invoices
    }
  }
}
</script>

<style>
#modalVisualFacTiers > .modal-dialog {
  max-width: 50%;
  height: 95%;
  margin-top: 1%;
}

#modalVisualFacTiers > .modal-dialog > div{
  height: 100%;
}
</style>
